module.exports = "<p>\n  lending works!\n</p>\n"